import * as React from 'react';
import { TerminalRemote } from 'services/clients/terminal';
import { Cell } from './Cell';

interface Props {
  terminals: TerminalRemote[];
  classes: Record<string, string>;
  lastRefreshData?: Record<
    string,
    Record<string, { last_recording_time: string; total_appointments: null | number }>
  >;
  selectedSlKey: string;
}

export const Cells: React.FC<Props> = (props) => {
  const { terminals, ...rest } = props;
  return (
    <>
      {terminals.map((terminal) => (
        <Cell key={terminal.key} terminal={terminal} {...rest} />
      ))}
    </>
  );
};
Cells.displayName = 'LastRefresh.Cells';
